import React from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';

import { UiControlPropsType } from 'shared/types';

import './styles.scss';

type PropsType = UiControlPropsType<boolean> & {
    children?: React.ReactNode;
    template?: 'base' | 'large';
};

export const UiSwitch = observer(function UiSwitch({ value, onChange, children, className, name = 'ui-switch', style, template = 'base' }: PropsType) {
    const classNames = classnames('ui-new-switch', className, `ui-new-switch--${template}`, {
        'ui-new-switch--enabled': value,
    });

    const handleClick = () => {
        onChange &&
            onChange({
                name,
                value: !value,
            });
    };

    return (
        <div className={classNames} onClick={handleClick} style={style}>
            <div className='ui-new-switch__control'>
                <span />
            </div>
            <span>{children}</span>
        </div>
    );
});
